export default __webpack_public_path__ + "static/media/my_journey_part1_8.338ab173.png";